import Button from '@base/Button/Button';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import styled from '@emotion/styled';
import MUIDialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { breakpoints, mobile, Spacings } from '@styles/index';
import * as React from 'react';
import { forwardRef } from 'react';
import { AnyArgVoidReturnFunction } from 'types/utils';

const Transition = forwardRef(function Transition(props, ref) {
  //  @ts-ignore
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ILiteUpgradeDialogProps {
  onClose: AnyArgVoidReturnFunction;
  upgradeSubscription: AnyArgVoidReturnFunction;
  message?: string;
}

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    &:not(:first-child) {
      margin-left: ${Spacings.SPACING_4B};
    }
  }
`;

const StyButton = styled(Button)`
  height: ${Spacings.SPACING_12B};
`;

const StyledDialog = styled(MUIDialog)`
  &.MuiDialog-root .MuiDialog-container .MuiPaper-root {
    position: absolute;
    bottom: 0px;
    border-radius: ${Spacings.SPACING_2B};
    @media only screen and (max-width: ${mobile.maxWidth}) {
      width: 95%;
      margin: ${Spacings.SPACING_4B};
    }
  }
`;

const StyP1 = styled(P1)`
  color: var(--color-text-secondary);
  max-width: 464px;
  margin: ${Spacings.SPACING_2B} auto ${Spacings.SPACING_8B} auto;
  text-align: center;
`;

const MsgWrapper = styled.div`
  width: 560px;
  padding: ${Spacings.SPACING_10B} ${Spacings.SPACING_12B};
  text-align: center;
  background-color: var(--color-base-1);

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
  }
`;

const LiteUpgradeDialog: React.FC<ILiteUpgradeDialogProps> = ({
  message,
  onClose,
  upgradeSubscription
}) => {
  return (
    <StyledDialog
      open
      // @ts-ignore
      TransitionComponent={Transition}
      onClose={onClose}
    >
      <MsgWrapper>
        <H3>Upgrade for full access</H3>
        <StyP1>{message}</StyP1>
        <ButtonsWrapper>
          <StyButton
            // @ts-ignore
            label="Maybe later"
            variant="hollow"
            color="black"
            onClick={onClose}
            grid={2}
            width="216px"
          />
          <StyButton
            // @ts-ignore
            label="Upgrade subscription"
            variant="filled"
            color="green"
            onClick={upgradeSubscription}
            grid={2}
            width="216px"
          />
        </ButtonsWrapper>
      </MsgWrapper>
    </StyledDialog>
  );
};

export default LiteUpgradeDialog;

LiteUpgradeDialog.defaultProps = {
  message:
    'Plus & Iconic learners can enroll into courses and batches. Also get access to notes and more self-study features.'
};
